<main id="main-content" class="main-content">
    <h2 class="form-header">1. Fire Report Details</h2>

    <mat-card>
        <div class="title">1a. Report Details</div>
        <div class="bar">&nbsp;</div>

        <div class="whole-line">
            <div class="data-div-long">
                <p class="data-title">Report name</p>
                <p class="data-info">{{report().report_name ?? "--"}}</p>
            </div>
            <div class="data-div">
                <p class="data-title">Type of Report</p>
                <p class="data-info">{{report().report_type ?? "--"}}</p>
            </div>
        </div>

        <div class="whole-line" *ngIf="report()">
            <div class="data-div">
                <p class="data-title">Fire name</p>
                <p class="data-info">{{reportList()[0].assessment.baer_name ?? "--"}}</p>
            </div>
            <div class="data-div">
                <p class="data-title">Region</p>
                <p class="data-info">{{reportList()[0].assessment.region ?? "--"}}</p>
            </div>
            <div class="data-div">
                <p class="data-title">Forest name</p>
                <p class="data-info">{{reportList()[0].assessment.forest_name ?? "--"}}</p>
            </div>
            <div class="data-div">
                <p class="data-title">H Code</p>
                <p class="data-info">{{report().h_code ?? "--"}}</p>
            </div>
            <div class="data-div">
                <p class="data-title">Date Contained</p>
                <p class="data-info">{{report().date_contained | date:"MM/dd/yyyy"}}</p>
            </div>
            <div class="data-div">
                <p class="data-title">Date of authorization</p>
                <p class="data-info">{{reportList()[0].submission_date | date:"MM/dd/yyyy"}}</p>
            </div>
            <div class="data-div-long">
                <p class="data-title">Total Funding Authorized in 2500-8</p>
                <p class="data-info">${{totalFunding | number: '1.0-0'}}</p>
            </div>
            <div class="data-div">
                <p class="data-title">Report date</p>
                <p class="data-info">{{report().created_on | date:"MM/dd/yyyy"}}</p>
            </div>
        </div>
    </mat-card>
    <mat-card>
        <div class="title">1b. Prepared by</div>
        <div class="bar">&nbsp;</div>
        <div class="whole-line">
            <div class="data-div">
                <p class="data-title">Name</p>
                <p class="data-info">{{report().prepared_name ?? "--"}}</p>
            </div>
            <div class="data-div">
                <p class="data-title">Email address</p>
                <p class="data-info">{{report().prepared_address ?? "--"}}</p>
            </div>
            <div class="data-div">
                <p class="data-title">Phone number</p>
                <p class="data-info">{{report().prepared_number ?? "--"}}</p>
            </div>
        </div>
    </mat-card>
</main>